<div class="dialog-header" *ngIf="product">
  <div class="title-group">
    <h1 class="product-name">{{ product.Name }}</h1>
    <h5 class="product-title">{{ getStepTitle() }} | SKU: {{ product.Id }} </h5>
  </div>
  <button mat-icon-button mat-dialog-close class="close-btn">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-content" *ngIf="product">
  <mat-stepper linear #stepper (selectionChange)="onStepChange($event)">
    <mat-step [stepControl]="productDetailFormGroup" state="number">
      <ng-template matStepLabel>Product Details</ng-template>
      <div class="tab-content">

        <div class="product-layout">
          <div class="product-image-container">
            <span class="photoLabel">Product Photo</span>
            <input type="file" #imageInput class="displynone" accept="image/*" (change)="onImageFileSelected($event)" />
            <div class="image-upload-wrapper">
              <img
                [src]="editedProduct.ImageUrl || product.ImageUrl || '/assets/images/default-product.jpg'"
                [alt]="product.Name"
                class="product-image"
              />
              <button mat-flat-button type="button" class="center-upload-btn" (click)="imageInput.click()">Upload</button>
            </div>
             <mat-error *ngIf="productDetailFormGroup.get('ImageUrl')?.hasError('required') && productDetailFormGroup.get('ImageUrl')?.touched">
              Please upload a product photo
            </mat-error>

            <mat-error *ngIf="productDetailFormGroup.get('ImageUrl')?.hasError('invalidFileType')">
              Unsupported file type. Please upload JPG/PNG.
            </mat-error>

            <mat-error *ngIf="productDetailFormGroup.get('ImageUrl')?.hasError('fileTooLarge')">
              Upload JPG/PNG at max allowed size (5MB). Please upload a smaller image.
            </mat-error>

            <div class="product-description-section" [formGroup]="productDetailFormGroup">
            <mat-form-field appearance="fill" class="product-input-field height100">
              <mat-label>Product Description</mat-label>
              <textarea 
                matInput
                maxlength="500"
                formControlName="Description"
                placeholder="Enter product description"
                rows="4">
              </textarea>

                  <mat-hint align="end">
                    {{ productDetailFormGroup.get('Description')?.value?.length || 0 }}/500
                  </mat-hint>

                  <mat-error *ngIf="productDetailFormGroup.get('Description')?.hasError('required') && (productDetailFormGroup.get('Description')?.touched || submitted)">
                    Description is required
                  </mat-error>

                  <mat-error *ngIf="productDetailFormGroup.get('Description')?.hasError('maxlength')">
                    Product description cannot exceed 500 characters
                  </mat-error>
            </mat-form-field>
          </div>
            <p class="requiredText">Required form labels ends with an *</p>
          </div>
          
          <div class="product-details">
            <span>Product Details</span>
              <div class="product-description-section">
                <mat-form-field appearance="fill" class="product-input-field" [formGroup]="productDetailFormGroup">
                  <mat-label>Product Name</mat-label>
                <input
                  matInput
                  formControlName="Name"
                  placeholder="Enter product name"
                  maxlength="100"
                />

                <mat-hint align="end">
                  {{ productDetailFormGroup.get('Name')?.value?.length || 0 }}/100
                </mat-hint>

                <mat-error *ngIf="productDetailFormGroup.get('Name')?.hasError('required') && (productDetailFormGroup.get('Name')?.touched || submitted)">
                    Product name is required
                  </mat-error>
                <mat-error *ngIf="productDetailFormGroup.get('Name')?.hasError('maxlength')">
                  Product name cannot exceed 100 characters
                </mat-error>
                </mat-form-field>
              </div>

              <div class="category-section" [formGroup]="productDetailFormGroup">
                 <mat-form-field appearance="fill" class="w100">
                  <mat-label>Category</mat-label>
                  <mat-select formControlName="Category" (selectionChange)="onCategorySelectionChange($event)" [compareWith]="compareById">
                    <mat-option *ngFor="let cat of productCategories" [value]="cat">
                      {{ cat.Name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>Sub Category</mat-label>
                  <mat-select formControlName="Subcategory" [compareWith]="compareById">
                    <mat-option *ngFor="let sub of subProductCategories" [value]="sub">
                      {{ sub.Name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              
              <div class="sku-details" *ngIf="false">
                <mat-form-field appearance="fill" class="product-input-field">
                  <mat-label>SKU (Optional)</mat-label>
                  <input matInput 
                         [ngModel]="productSku" 
                         (ngModelChange)="onSkuChange($event)"
                         placeholder="Enter SKU (optional)"
                         type="text"
                         (input)="onSkuChange($event)">
                </mat-form-field>
              </div>

              <div class="merchant-form">
                  <span>Tags (Optional)</span>
                  <div class="merchant-sub-label">TIP: Use Tags help inform customers about dietary requirements (example Vegan)</div>
                  <div class="flex flex-row">
                      <div class="erchant-column flex" *ngIf="allTags">
                           <mat-form-field appearance="fill" class="product-tag-field">
                            <mat-label>Tags</mat-label>
                            <mat-select [(value)]="selectedTag">
                              <mat-option>
                                
                              </mat-option>
                              <mat-option *ngFor="let tag of allTags" [value]="tag">
                                {{ tag.Name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                          <button mat-icon-button color="primary" (click)="addTag()" class="product-plus-tag-btn">
                            <mat-icon>add</mat-icon>
                          </button>
                      </div>
                  </div>

                  <div class="marTop15">
                        <span class="product-tag" *ngFor="let tag of productTags; let i = index;">
                            {{tag}} <i class="pi pi-times remove-product-tag" (click)="removeTag(i)"></i>
                        </span>
                  </div>

              </div>
          </div>
        </div>
      </div>
    </mat-step>

    <mat-step [stepControl]="pricingFormGroup">
      <ng-template matStepLabel>Pricing</ng-template>
      <div class="tab-content">
        <app-pricing-tab [product]="product" [pricingFormGroup]="pricingFormGroup"></app-pricing-tab>
      </div>
    </mat-step>

    <mat-step [stepControl]="uomFormGroup">
      <ng-template matStepLabel>UOM</ng-template>
      <div class="tab-content">
        <app-uom-tab [product]="product" [uomFormGroup]="uomFormGroup" (uomDataChanged)="onUomDataChanged($event)"></app-uom-tab>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Availability</ng-template>
      <div class="tab-content">
        <app-availability-tab [product]="product" [availabilityControl]="availabilityControl" [storeSelectedSet]="storeSelectedSet" (availabilityDataChanged)="onAvailabilityDataChanged($event)"></app-availability-tab>
      </div>
    </mat-step>

    <ng-template matStepperIcon="edit">
      <mat-icon>check</mat-icon>
    </ng-template>
  </mat-stepper>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" *ngIf="product && isStepperReady">
  <button mat-button 
          class="discard"
          (click)="onCancel()" 
          [disabled]="loading"
          *ngIf="stepper.selectedIndex === 0">
    Discard
  </button>

  <button mat-button 
          (click)="goBack()" 
          [disabled]="loading"
          *ngIf="stepper.selectedIndex > 0">
    <mat-icon>arrow_back</mat-icon>
    Back
  </button>

  <button mat-flat-button 
          (click)="onNextStep()" 
          [disabled]="loading || isCurrentStepInvalid()"
          *ngIf="stepper.selectedIndex !== stepper.steps.length - 1">
    Next
    <mat-icon iconPositionEnd>arrow_forward</mat-icon>
  </button>

  <button mat-flat-button 
          color="primary" 
          (click)="onSave()"
          [disabled]="loading || isCurrentStepInvalid()"
          *ngIf="stepper.selectedIndex === stepper.steps.length - 1">
    <span *ngIf="!loading">Save Changes</span>
  </button>
   <mat-spinner *ngIf="loading" diameter="20" class="center-spinner"></mat-spinner>
</mat-dialog-actions>

<div *ngIf="!product" class="empty-state">
  <mat-icon class="empty-icon">error_outline</mat-icon>
  <h3>Product not found</h3>
  <p>The requested product could not be loaded.</p>
</div>
